/* @generated */
import tokens from "../design-tokens/dist/dig/index.module.esm.js";
import { createJoinedObject } from "./utils.esm.js";
const { Spacing: _spacing } = tokens;
const spacing = {
  ..._spacing.Dimension,
  ...createJoinedObject(_spacing.Micro, "Micro"),
  ...createJoinedObject(_spacing.Macro, "Macro")
};
export {
  spacing
};
